export const formatPriceRange = (level, chinese = true) => {
  if (level == null) return '';
  if (level <= 1) return chinese ? 'NT$300 以下／人' : 'Under NT$300/person';
  if (level === 2) return chinese ? 'NT$300–800／人' : 'NT$300–800/person';
  return chinese ? 'NT$800 以上／人' : 'NT$800+/person';
};
